export enum Currencies {
  local = 'localCurrency',
  base = 'baseCurrency',
}

export enum UserRoleType {
  CPak_Sales_Rep = 'CPak_Sales_Rep',
  CPak_Affiliate = 'CPak_Affiliate',
  CPak_Contract_Admin = 'CPak_Contract_Admin',
  CPak_Admin = 'CPak_Admin',
  CPak_Read_only = 'CPak_Read_only',
}

export enum PackDescriptionType {
  COMMON = 'packDescription',
  CUSTOMER = 'alternatePackDescription',
}
